import { render, staticRenderFns } from "./matrixChoiceItem.vue?vue&type=template&id=0ae96b40"
import script from "./matrixChoiceItem.vue?vue&type=script&lang=js"
export * from "./matrixChoiceItem.vue?vue&type=script&lang=js"
import style0 from "./matrixChoiceItem.vue?vue&type=style&index=0&id=0ae96b40&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports